import { createContext, useContext } from 'react'

// REBUILD-531: open-logging context for report comments. Supplied by the report JSON payloads
// (day-list, single-log, and day-occurrences — sibling keys to the logs) so the CommentsPanel
// add-comment flow can offer logger selection + "Add new user" on an OL instrument and stay
// hidden on an authenticated-users-only one. Shared across LogDetailsDialog and
// TaskDayOccurrencesDialog so both report-comment surfaces behave identically.
export interface CommentLoggingContext {
  logAuthenticationCode: string | null
  loggerOptions: { id: number; label: string }[]
  instrumentId: number | null
}

export const CommentLoggingContextProvider = createContext<CommentLoggingContext>({
  logAuthenticationCode: null,
  loggerOptions: [],
  instrumentId: null,
})

export const useCommentLoggingContext = () => useContext(CommentLoggingContextProvider)
